import { IHttpApi } from '@cian/http-api/shared';
import {
  fetchCianApiSiteV1GetRegionCities,
  ICianApiSiteV1GetRegionCitiesRequest,
  TCianApiSiteV1GetRegionCitiesResponse,
} from '../repositories/monolith-python/cian-api/site/v1/get-region-cities';
import { IGetRegionCitiesResponseSchema48 } from '../repositories/monolith-python/entities/schemas/GetRegionCitiesResponseSchema48';

export async function getRegionCities(
  httpApi: IHttpApi,
  parameters: ICianApiSiteV1GetRegionCitiesRequest,
  subdomain?: string,
): Promise<IGetRegionCitiesResponseSchema48> {
  const { response, statusCode } = await fetchCianApiSiteV1GetRegionCities<
    TCianApiSiteV1GetRegionCitiesResponse,
    TCianApiSiteV1GetRegionCitiesResponse
  >({
    httpApi,
    parameters,
    config: {
      subdomain: subdomain || 'www',
    },
  });

  if (statusCode !== 200) {
    throw response;
  }

  return response;
}
